import SlideShow from "./slideShow"

const Room = (props) => {
    const { name, equipments, size, priceLabel, price, images, reverse } = props

    return (
        <div className={reverse ? 'room reverse' : 'room'}>
            <div className='room-media'>
                <SlideShow images={images} />
            </div>
            <div className='room-body'>
                <p className='room-name'>{name}</p>
                <div className='room-rule'></div>
                <p className='room-equipments'>
                    {equipments.join('・')}
                    {size && <><br />{size}</>}
                </p>
                <p className='room-price'>
                    <span className='label'>{priceLabel}</span>
                    <span className='value'>{price}</span>
                </p>
            </div>
        </div>
    )
}

export default Room
